import { useParams } from 'react-router-dom';
import { LandingNav } from '@/components/landing/LandingNav';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { useLanguage } from '@/contexts/LanguageContext';

export function LandingPage() {
  const { pageName } = useParams<{ pageName: string }>();
  const { dir, t } = useLanguage();
  
  // Decode and format the page title
  const pageTitle = pageName ? decodeURIComponent(pageName).replace(/-/g, ' ') : '';

  return (
    <div className="min-h-screen bg-white" dir={dir}>
      <LandingNav />
      
      {/* Hero Section */}
      <section className="relative pt-20 pb-12">
        {/* Background with gradient overlay */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url("https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=2000")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#004250]/95 via-[#006778]/90 to-[#7dda55]/85"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight text-white">
              {pageTitle}
            </h1>
            <div className="w-24 h-1 bg-[#7dda55] mx-auto"></div>
          </div>
        </div>

        {/* Decorative gradient at bottom */}
        <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
      </section>

      {/* Main Content */}
      <main className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-gray-50 rounded-lg shadow-md p-8">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 leading-relaxed">
                {t('landing.dynamicPage.pageContent')}: {pageTitle}
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                {t('landing.dynamicPage.comingSoon')}
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <LandingFooter />
    </div>
  );
}

